import makeRequest from './base.request'

export const getInstrucoes = async (idExam) => {
    try {
        const response = await makeRequest.get(`simulado/instrucao?exam=${idExam}`);

        var instrucao = response.instrucao[0];
        return instrucao;
    } catch (error) {
        console.error(error);
    }
}


export const getQuestao = async (idExam, numQuestao, idStudent) => {
    try {
        const student = idStudent ? '&student=' + idStudent : ''
        const response = await makeRequest.get(`simulado/questoes?exam=${idExam}&question=${numQuestao}${student}`);
        // console.log(response)
        var questao = response.questoes[0][0].q[0];
        return questao;

    } catch (error) {
        console.error("Erro no getQuestao.", error);
    }
}

export const getMarcacoes = async (idExam) => {
    try {
        const response = await makeRequest.get(`simulado/questoes/marcacoes?exam=${idExam}`);
        // console.log(response[0]);
        var marcacoes = response[0];
        return marcacoes;

    } catch (error) {
        console.error(error)
    }
}

export const getGabarito = async (idExam, idStudent) => {
    try {
        const student = idStudent ? '&student=' + idStudent : ''
        const response = await makeRequest.get(`simulado/questoes/gabarito?exam=${idExam}${student}`);

        var gabarito = response[0];
        return gabarito;

    } catch (error) {
        console.error(error)
    }
}


export const setIniciar = async (idExam, idLanguage) => {
    try {
        const inicio = await makeRequest.post('simulado/iniciar', { idExam: idExam, idLanguage: idLanguage })
        return inicio
    } catch (error) {
        console.error(error)
    }
}

export const setSituacaoSimulado = async () => {
    try {
        const inicio = await makeRequest.post('simulado/status-aluno')
        return inicio
    } catch (error) {
        console.error(error)
    }
}

export const setSituacaoSimuladoSerie = async (idGrade) => {
    try {
        const inicio = await makeRequest.post('simulado/status-serie', { idGrade: idGrade })
        return inicio
    } catch (error) {
        console.error(error)
    }
}

export const setResposta = async (idExam, respostaQuestao) => {
    try {

        const response = await makeRequest.post('simulado/questoes', {
            idExam: idExam,
            finishPracticeTest: false,
            questions: [respostaQuestao]
        })

        return response.message;

    } catch (error) {
        console.error(error)
    }
}

export const setNotasTri = async (idExam = 0) => {
    try {
        const notas = await makeRequest.post('simulado/notatri', { idExam: idExam })
        return notas
    } catch (error) {
        console.error(error)
    }
}

export const setNotasTriSerie = async (idGrade) => {
    try {
        console.log('setNotasTriSerie ', idGrade)
        const notas = await makeRequest.post('simulado/notatri-serie', { idGrade: idGrade })
        return notas
    } catch (error) {
        console.error(error)
    }
}

export const setFinalizarSimulado = async (idExam) => {
    try {
        const response = await makeRequest.post('simulado/questoes', {
            idExam: idExam,
            finishPracticeTest: true,
            //questions: []
        })

        return response.message;
    } catch (error) {
        console.error(error)
    }
}

export const setConquistaUsuario = async (codeAchievement, context) => {
    try {
        const response = await makeRequest.post('conquistas', {
            codeAchievement,
            context
        })
        return response.message;
    } catch (error) {
        console.error(error)
    }
}

export const getStatusSimuladoAluno = async () => {
    try {
        const response = await makeRequest.get('simulado/status-aluno')
        return response;
    } catch (error) {
        console.error(error)
    }
}

export const getStatusSimuladoSerie = async (idGrade) => {
    try {
        const response = await makeRequest.get(`simulado/status-serie?grade=${idGrade}`)
        return response;
    } catch (error) {
        console.error(error)
    }
}
